/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as PortalRouteImport } from './routes/portal'
import { Route as LoginRouteImport } from './routes/login'
import { Route as Connect_rewireRouteImport } from './routes/connect_rewire'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StaffIndexRouteImport } from './routes/staff/index'
import { Route as RdpIndexRouteImport } from './routes/rdp/index'
import { Route as PortalIndexRouteImport } from './routes/portal/index'
import { Route as FilingsIndexRouteImport } from './routes/filings/index'
import { Route as Cbl_disputesIndexRouteImport } from './routes/cbl_disputes/index'
import { Route as BuildingsIndexRouteImport } from './routes/buildings/index'
import { Route as StaffChatDebugRouteImport } from './routes/staff/chat-debug'
import { Route as PortalWorkflowRouteImport } from './routes/portal/workflow'
import { Route as PortalTrackerRouteImport } from './routes/portal/tracker'
import { Route as PortalTeamRouteImport } from './routes/portal/team'
import { Route as PortalSettingsRouteImport } from './routes/portal/settings'
import { Route as PortalLl87PlannerRouteImport } from './routes/portal/ll87-planner'
import { Route as PortalChatRouteImport } from './routes/portal/chat'
import { Route as PoliciesTosRouteImport } from './routes/policies/tos'
import { Route as PoliciesPrivacyRouteImport } from './routes/policies/privacy'
import { Route as PoliciesData_usageRouteImport } from './routes/policies/data_usage'
import { Route as OwnerTokenRouteImport } from './routes/owner/$token'
import { Route as ExternalUtility_scope_selectionRouteImport } from './routes/external/utility_scope_selection'
import { Route as ExternalPassword_reset_requestRouteImport } from './routes/external/password_reset_request'
import { Route as ExternalPassword_reset_confirmRouteImport } from './routes/external/password_reset_confirm'
import { Route as ExternalNew_utility_connectionRouteImport } from './routes/external/new_utility_connection'
import { Route as ExternalInitiate_utility_authRouteImport } from './routes/external/initiate_utility_auth'
import { Route as ExternalAuth_successRouteImport } from './routes/external/auth_success'
import { Route as ChatDevTraceDemoRouteImport } from './routes/chat-dev/trace-demo'
import { Route as ChatDevCardsDemoRouteImport } from './routes/chat-dev/cards-demo'
import { Route as Cbl_disputesLl97SubmissionIdRouteImport } from './routes/cbl_disputes/$ll97SubmissionId'
import { Route as BuildingsBuildingIdRouteImport } from './routes/buildings/$buildingId'
import { Route as StaffLl97SubmissionIdRouteImport } from './routes/staff/ll97/$submissionId'
import { Route as StaffLl88SubmissionIdRouteImport } from './routes/staff/ll88/$submissionId'
import { Route as StaffCblDisputeDisputeIdRouteImport } from './routes/staff/cbl-dispute/$disputeId'
import { Route as RdpLl97SubmissionIdRouteImport } from './routes/rdp/ll97/$submissionId'
import { Route as RdpLl88SubmissionIdRouteImport } from './routes/rdp/ll88/$submissionId'
import { Route as PortalComplianceLl152RouteImport } from './routes/portal/compliance/ll152'
import { Route as PortalBuildingsBuildingIdRouteImport } from './routes/portal/buildings/$buildingId'
import { Route as OwnerTokenListRouteImport } from './routes/owner_/$token/list'
import { Route as Account_activationUidTokenRouteImport } from './routes/account_activation.$uid.$token'
import { Route as VendorsLl87VendorIdIndexRouteImport } from './routes/vendors_/ll87_/$vendorId/index'
import { Route as PortalBuildingsBuildingIdLl97RouteImport } from './routes/portal/buildings_/$buildingId/ll97'
import { Route as BuildingsBuildingIdLl97Ll97SubmissionIdIndexRouteImport } from './routes/buildings_/$buildingId/ll97_/$ll97SubmissionId/index'
import { Route as BuildingsBuildingIdLl88Ll88SubmissionIdIndexRouteImport } from './routes/buildings_/$buildingId/ll88_/$ll88SubmissionId/index'
import { Route as BuildingsBuildingIdLl97Ll97SubmissionIdOverviewRouteImport } from './routes/buildings_/$buildingId/ll97_/$ll97SubmissionId/overview'
import { Route as BuildingsBuildingIdLl88Ll88SubmissionIdOverviewRouteImport } from './routes/buildings_/$buildingId/ll88_/$ll88SubmissionId/overview'
import { Route as PortalBuildingsBuildingIdLl87Ll87SubmissionIdIndexRouteImport } from './routes/portal/buildings_/$buildingId/ll87_/$ll87SubmissionId/index'
import { Route as PortalBuildingsBuildingIdLl87Ll87SubmissionIdOverviewRouteImport } from './routes/portal/buildings_/$buildingId/ll87_/$ll87SubmissionId/overview'

const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRoute = PortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const Connect_rewireRoute = Connect_rewireRouteImport.update({
  id: '/connect_rewire',
  path: '/connect_rewire',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffIndexRoute = StaffIndexRouteImport.update({
  id: '/staff/',
  path: '/staff/',
  getParentRoute: () => rootRouteImport,
} as any)
const RdpIndexRoute = RdpIndexRouteImport.update({
  id: '/rdp/',
  path: '/rdp/',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalRoute,
} as any)
const FilingsIndexRoute = FilingsIndexRouteImport.update({
  id: '/filings/',
  path: '/filings/',
  getParentRoute: () => rootRouteImport,
} as any)
const Cbl_disputesIndexRoute = Cbl_disputesIndexRouteImport.update({
  id: '/cbl_disputes/',
  path: '/cbl_disputes/',
  getParentRoute: () => rootRouteImport,
} as any)
const BuildingsIndexRoute = BuildingsIndexRouteImport.update({
  id: '/buildings/',
  path: '/buildings/',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffChatDebugRoute = StaffChatDebugRouteImport.update({
  id: '/staff/chat-debug',
  path: '/staff/chat-debug',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalWorkflowRoute = PortalWorkflowRouteImport.update({
  id: '/workflow',
  path: '/workflow',
  getParentRoute: () => PortalRoute,
} as any)
const PortalTrackerRoute = PortalTrackerRouteImport.update({
  id: '/tracker',
  path: '/tracker',
  getParentRoute: () => PortalRoute,
} as any)
const PortalTeamRoute = PortalTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => PortalRoute,
} as any)
const PortalSettingsRoute = PortalSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => PortalRoute,
} as any)
const PortalLl87PlannerRoute = PortalLl87PlannerRouteImport.update({
  id: '/ll87-planner',
  path: '/ll87-planner',
  getParentRoute: () => PortalRoute,
} as any)
const PortalChatRoute = PortalChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => PortalRoute,
} as any)
const PoliciesTosRoute = PoliciesTosRouteImport.update({
  id: '/policies/tos',
  path: '/policies/tos',
  getParentRoute: () => rootRouteImport,
} as any)
const PoliciesPrivacyRoute = PoliciesPrivacyRouteImport.update({
  id: '/policies/privacy',
  path: '/policies/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PoliciesData_usageRoute = PoliciesData_usageRouteImport.update({
  id: '/policies/data_usage',
  path: '/policies/data_usage',
  getParentRoute: () => rootRouteImport,
} as any)
const OwnerTokenRoute = OwnerTokenRouteImport.update({
  id: '/owner/$token',
  path: '/owner/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ExternalUtility_scope_selectionRoute =
  ExternalUtility_scope_selectionRouteImport.update({
    id: '/external/utility_scope_selection',
    path: '/external/utility_scope_selection',
    getParentRoute: () => rootRouteImport,
  } as any)
const ExternalPassword_reset_requestRoute =
  ExternalPassword_reset_requestRouteImport.update({
    id: '/external/password_reset_request',
    path: '/external/password_reset_request',
    getParentRoute: () => rootRouteImport,
  } as any)
const ExternalPassword_reset_confirmRoute =
  ExternalPassword_reset_confirmRouteImport.update({
    id: '/external/password_reset_confirm',
    path: '/external/password_reset_confirm',
    getParentRoute: () => rootRouteImport,
  } as any)
const ExternalNew_utility_connectionRoute =
  ExternalNew_utility_connectionRouteImport.update({
    id: '/external/new_utility_connection',
    path: '/external/new_utility_connection',
    getParentRoute: () => rootRouteImport,
  } as any)
const ExternalInitiate_utility_authRoute =
  ExternalInitiate_utility_authRouteImport.update({
    id: '/external/initiate_utility_auth',
    path: '/external/initiate_utility_auth',
    getParentRoute: () => rootRouteImport,
  } as any)
const ExternalAuth_successRoute = ExternalAuth_successRouteImport.update({
  id: '/external/auth_success',
  path: '/external/auth_success',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatDevTraceDemoRoute = ChatDevTraceDemoRouteImport.update({
  id: '/chat-dev/trace-demo',
  path: '/chat-dev/trace-demo',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatDevCardsDemoRoute = ChatDevCardsDemoRouteImport.update({
  id: '/chat-dev/cards-demo',
  path: '/chat-dev/cards-demo',
  getParentRoute: () => rootRouteImport,
} as any)
const Cbl_disputesLl97SubmissionIdRoute =
  Cbl_disputesLl97SubmissionIdRouteImport.update({
    id: '/cbl_disputes/$ll97SubmissionId',
    path: '/cbl_disputes/$ll97SubmissionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildingsBuildingIdRoute = BuildingsBuildingIdRouteImport.update({
  id: '/buildings/$buildingId',
  path: '/buildings/$buildingId',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffLl97SubmissionIdRoute = StaffLl97SubmissionIdRouteImport.update({
  id: '/staff/ll97/$submissionId',
  path: '/staff/ll97/$submissionId',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffLl88SubmissionIdRoute = StaffLl88SubmissionIdRouteImport.update({
  id: '/staff/ll88/$submissionId',
  path: '/staff/ll88/$submissionId',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffCblDisputeDisputeIdRoute =
  StaffCblDisputeDisputeIdRouteImport.update({
    id: '/staff/cbl-dispute/$disputeId',
    path: '/staff/cbl-dispute/$disputeId',
    getParentRoute: () => rootRouteImport,
  } as any)
const RdpLl97SubmissionIdRoute = RdpLl97SubmissionIdRouteImport.update({
  id: '/rdp/ll97/$submissionId',
  path: '/rdp/ll97/$submissionId',
  getParentRoute: () => rootRouteImport,
} as any)
const RdpLl88SubmissionIdRoute = RdpLl88SubmissionIdRouteImport.update({
  id: '/rdp/ll88/$submissionId',
  path: '/rdp/ll88/$submissionId',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalComplianceLl152Route = PortalComplianceLl152RouteImport.update({
  id: '/compliance/ll152',
  path: '/compliance/ll152',
  getParentRoute: () => PortalRoute,
} as any)
const PortalBuildingsBuildingIdRoute =
  PortalBuildingsBuildingIdRouteImport.update({
    id: '/buildings/$buildingId',
    path: '/buildings/$buildingId',
    getParentRoute: () => PortalRoute,
  } as any)
const OwnerTokenListRoute = OwnerTokenListRouteImport.update({
  id: '/owner_/$token/list',
  path: '/owner/$token/list',
  getParentRoute: () => rootRouteImport,
} as any)
const Account_activationUidTokenRoute =
  Account_activationUidTokenRouteImport.update({
    id: '/account_activation/$uid/$token',
    path: '/account_activation/$uid/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const VendorsLl87VendorIdIndexRoute =
  VendorsLl87VendorIdIndexRouteImport.update({
    id: '/vendors_/ll87_/$vendorId/',
    path: '/vendors/ll87/$vendorId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const PortalBuildingsBuildingIdLl97Route =
  PortalBuildingsBuildingIdLl97RouteImport.update({
    id: '/buildings_/$buildingId/ll97',
    path: '/buildings/$buildingId/ll97',
    getParentRoute: () => PortalRoute,
  } as any)
const BuildingsBuildingIdLl97Ll97SubmissionIdIndexRoute =
  BuildingsBuildingIdLl97Ll97SubmissionIdIndexRouteImport.update({
    id: '/buildings_/$buildingId/ll97_/$ll97SubmissionId/',
    path: '/buildings/$buildingId/ll97/$ll97SubmissionId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildingsBuildingIdLl88Ll88SubmissionIdIndexRoute =
  BuildingsBuildingIdLl88Ll88SubmissionIdIndexRouteImport.update({
    id: '/buildings_/$buildingId/ll88_/$ll88SubmissionId/',
    path: '/buildings/$buildingId/ll88/$ll88SubmissionId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildingsBuildingIdLl97Ll97SubmissionIdOverviewRoute =
  BuildingsBuildingIdLl97Ll97SubmissionIdOverviewRouteImport.update({
    id: '/buildings_/$buildingId/ll97_/$ll97SubmissionId/overview',
    path: '/buildings/$buildingId/ll97/$ll97SubmissionId/overview',
    getParentRoute: () => rootRouteImport,
  } as any)
const BuildingsBuildingIdLl88Ll88SubmissionIdOverviewRoute =
  BuildingsBuildingIdLl88Ll88SubmissionIdOverviewRouteImport.update({
    id: '/buildings_/$buildingId/ll88_/$ll88SubmissionId/overview',
    path: '/buildings/$buildingId/ll88/$ll88SubmissionId/overview',
    getParentRoute: () => rootRouteImport,
  } as any)
const PortalBuildingsBuildingIdLl87Ll87SubmissionIdIndexRoute =
  PortalBuildingsBuildingIdLl87Ll87SubmissionIdIndexRouteImport.update({
    id: '/buildings_/$buildingId/ll87_/$ll87SubmissionId/',
    path: '/buildings/$buildingId/ll87/$ll87SubmissionId/',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalBuildingsBuildingIdLl87Ll87SubmissionIdOverviewRoute =
  PortalBuildingsBuildingIdLl87Ll87SubmissionIdOverviewRouteImport.update({
    id: '/buildings_/$buildingId/ll87_/$ll87SubmissionId/overview',
    path: '/buildings/$buildingId/ll87/$ll87SubmissionId/overview',
    getParentRoute: () => PortalRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/connect_rewire': typeof Connect_rewireRoute
  '/login': typeof LoginRoute
  '/portal': typeof PortalRouteWithChildren
  '/register': typeof RegisterRoute
  '/settings': typeof SettingsRoute
  '/welcome': typeof WelcomeRoute
  '/buildings/$buildingId': typeof BuildingsBuildingIdRoute
  '/cbl_disputes/$ll97SubmissionId': typeof Cbl_disputesLl97SubmissionIdRoute
  '/chat-dev/cards-demo': typeof ChatDevCardsDemoRoute
  '/chat-dev/trace-demo': typeof ChatDevTraceDemoRoute
  '/external/auth_success': typeof ExternalAuth_successRoute
  '/external/initiate_utility_auth': typeof ExternalInitiate_utility_authRoute
  '/external/new_utility_connection': typeof ExternalNew_utility_connectionRoute
  '/external/password_reset_confirm': typeof ExternalPassword_reset_confirmRoute
  '/external/password_reset_request': typeof ExternalPassword_reset_requestRoute
  '/external/utility_scope_selection': typeof ExternalUtility_scope_selectionRoute
  '/owner/$token': typeof OwnerTokenRoute
  '/policies/data_usage': typeof PoliciesData_usageRoute
  '/policies/privacy': typeof PoliciesPrivacyRoute
  '/policies/tos': typeof PoliciesTosRoute
  '/portal/chat': typeof PortalChatRoute
  '/portal/ll87-planner': typeof PortalLl87PlannerRoute
  '/portal/settings': typeof PortalSettingsRoute
  '/portal/team': typeof PortalTeamRoute
  '/portal/tracker': typeof PortalTrackerRoute
  '/portal/workflow': typeof PortalWorkflowRoute
  '/staff/chat-debug': typeof StaffChatDebugRoute
  '/buildings': typeof BuildingsIndexRoute
  '/cbl_disputes': typeof Cbl_disputesIndexRoute
  '/filings': typeof FilingsIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/rdp': typeof RdpIndexRoute
  '/staff': typeof StaffIndexRoute
  '/account_activation/$uid/$token': typeof Account_activationUidTokenRoute
  '/owner/$token/list': typeof OwnerTokenListRoute
  '/portal/buildings/$buildingId': typeof PortalBuildingsBuildingIdRoute
  '/portal/compliance/ll152': typeof PortalComplianceLl152Route
  '/rdp/ll88/$submissionId': typeof RdpLl88SubmissionIdRoute
  '/rdp/ll97/$submissionId': typeof RdpLl97SubmissionIdRoute
  '/staff/cbl-dispute/$disputeId': typeof StaffCblDisputeDisputeIdRoute
  '/staff/ll88/$submissionId': typeof StaffLl88SubmissionIdRoute
  '/staff/ll97/$submissionId': typeof StaffLl97SubmissionIdRoute
  '/portal/buildings/$buildingId/ll97': typeof PortalBuildingsBuildingIdLl97Route
  '/vendors/ll87/$vendorId': typeof VendorsLl87VendorIdIndexRoute
  '/buildings/$buildingId/ll88/$ll88SubmissionId/overview': typeof BuildingsBuildingIdLl88Ll88SubmissionIdOverviewRoute
  '/buildings/$buildingId/ll97/$ll97SubmissionId/overview': typeof BuildingsBuildingIdLl97Ll97SubmissionIdOverviewRoute
  '/buildings/$buildingId/ll88/$ll88SubmissionId': typeof BuildingsBuildingIdLl88Ll88SubmissionIdIndexRoute
  '/buildings/$buildingId/ll97/$ll97SubmissionId': typeof BuildingsBuildingIdLl97Ll97SubmissionIdIndexRoute
  '/portal/buildings/$buildingId/ll87/$ll87SubmissionId/overview': typeof PortalBuildingsBuildingIdLl87Ll87SubmissionIdOverviewRoute
  '/portal/buildings/$buildingId/ll87/$ll87SubmissionId': typeof PortalBuildingsBuildingIdLl87Ll87SubmissionIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/connect_rewire': typeof Connect_rewireRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/settings': typeof SettingsRoute
  '/welcome': typeof WelcomeRoute
  '/buildings/$buildingId': typeof BuildingsBuildingIdRoute
  '/cbl_disputes/$ll97SubmissionId': typeof Cbl_disputesLl97SubmissionIdRoute
  '/chat-dev/cards-demo': typeof ChatDevCardsDemoRoute
  '/chat-dev/trace-demo': typeof ChatDevTraceDemoRoute
  '/external/auth_success': typeof ExternalAuth_successRoute
  '/external/initiate_utility_auth': typeof ExternalInitiate_utility_authRoute
  '/external/new_utility_connection': typeof ExternalNew_utility_connectionRoute
  '/external/password_reset_confirm': typeof ExternalPassword_reset_confirmRoute
  '/external/password_reset_request': typeof ExternalPassword_reset_requestRoute
  '/external/utility_scope_selection': typeof ExternalUtility_scope_selectionRoute
  '/owner/$token': typeof OwnerTokenRoute
  '/policies/data_usage': typeof PoliciesData_usageRoute
  '/policies/privacy': typeof PoliciesPrivacyRoute
  '/policies/tos': typeof PoliciesTosRoute
  '/portal/chat': typeof PortalChatRoute
  '/portal/ll87-planner': typeof PortalLl87PlannerRoute
  '/portal/settings': typeof PortalSettingsRoute
  '/portal/team': typeof PortalTeamRoute
  '/portal/tracker': typeof PortalTrackerRoute
  '/portal/workflow': typeof PortalWorkflowRoute
  '/staff/chat-debug': typeof StaffChatDebugRoute
  '/buildings': typeof BuildingsIndexRoute
  '/cbl_disputes': typeof Cbl_disputesIndexRoute
  '/filings': typeof FilingsIndexRoute
  '/portal': typeof PortalIndexRoute
  '/rdp': typeof RdpIndexRoute
  '/staff': typeof StaffIndexRoute
  '/account_activation/$uid/$token': typeof Account_activationUidTokenRoute
  '/owner/$token/list': typeof OwnerTokenListRoute
  '/portal/buildings/$buildingId': typeof PortalBuildingsBuildingIdRoute
  '/portal/compliance/ll152': typeof PortalComplianceLl152Route
  '/rdp/ll88/$submissionId': typeof RdpLl88SubmissionIdRoute
  '/rdp/ll97/$submissionId': typeof RdpLl97SubmissionIdRoute
  '/staff/cbl-dispute/$disputeId': typeof StaffCblDisputeDisputeIdRoute
  '/staff/ll88/$submissionId': typeof StaffLl88SubmissionIdRoute
  '/staff/ll97/$submissionId': typeof StaffLl97SubmissionIdRoute
  '/portal/buildings/$buildingId/ll97': typeof PortalBuildingsBuildingIdLl97Route
  '/vendors/ll87/$vendorId': typeof VendorsLl87VendorIdIndexRoute
  '/buildings/$buildingId/ll88/$ll88SubmissionId/overview': typeof BuildingsBuildingIdLl88Ll88SubmissionIdOverviewRoute
  '/buildings/$buildingId/ll97/$ll97SubmissionId/overview': typeof BuildingsBuildingIdLl97Ll97SubmissionIdOverviewRoute
  '/buildings/$buildingId/ll88/$ll88SubmissionId': typeof BuildingsBuildingIdLl88Ll88SubmissionIdIndexRoute
  '/buildings/$buildingId/ll97/$ll97SubmissionId': typeof BuildingsBuildingIdLl97Ll97SubmissionIdIndexRoute
  '/portal/buildings/$buildingId/ll87/$ll87SubmissionId/overview': typeof PortalBuildingsBuildingIdLl87Ll87SubmissionIdOverviewRoute
  '/portal/buildings/$buildingId/ll87/$ll87SubmissionId': typeof PortalBuildingsBuildingIdLl87Ll87SubmissionIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/connect_rewire': typeof Connect_rewireRoute
  '/login': typeof LoginRoute
  '/portal': typeof PortalRouteWithChildren
  '/register': typeof RegisterRoute
  '/settings': typeof SettingsRoute
  '/welcome': typeof WelcomeRoute
  '/buildings/$buildingId': typeof BuildingsBuildingIdRoute
  '/cbl_disputes/$ll97SubmissionId': typeof Cbl_disputesLl97SubmissionIdRoute
  '/chat-dev/cards-demo': typeof ChatDevCardsDemoRoute
  '/chat-dev/trace-demo': typeof ChatDevTraceDemoRoute
  '/external/auth_success': typeof ExternalAuth_successRoute
  '/external/initiate_utility_auth': typeof ExternalInitiate_utility_authRoute
  '/external/new_utility_connection': typeof ExternalNew_utility_connectionRoute
  '/external/password_reset_confirm': typeof ExternalPassword_reset_confirmRoute
  '/external/password_reset_request': typeof ExternalPassword_reset_requestRoute
  '/external/utility_scope_selection': typeof ExternalUtility_scope_selectionRoute
  '/owner/$token': typeof OwnerTokenRoute
  '/policies/data_usage': typeof PoliciesData_usageRoute
  '/policies/privacy': typeof PoliciesPrivacyRoute
  '/policies/tos': typeof PoliciesTosRoute
  '/portal/chat': typeof PortalChatRoute
  '/portal/ll87-planner': typeof PortalLl87PlannerRoute
  '/portal/settings': typeof PortalSettingsRoute
  '/portal/team': typeof PortalTeamRoute
  '/portal/tracker': typeof PortalTrackerRoute
  '/portal/workflow': typeof PortalWorkflowRoute
  '/staff/chat-debug': typeof StaffChatDebugRoute
  '/buildings/': typeof BuildingsIndexRoute
  '/cbl_disputes/': typeof Cbl_disputesIndexRoute
  '/filings/': typeof FilingsIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/rdp/': typeof RdpIndexRoute
  '/staff/': typeof StaffIndexRoute
  '/account_activation/$uid/$token': typeof Account_activationUidTokenRoute
  '/owner_/$token/list': typeof OwnerTokenListRoute
  '/portal/buildings/$buildingId': typeof PortalBuildingsBuildingIdRoute
  '/portal/compliance/ll152': typeof PortalComplianceLl152Route
  '/rdp/ll88/$submissionId': typeof RdpLl88SubmissionIdRoute
  '/rdp/ll97/$submissionId': typeof RdpLl97SubmissionIdRoute
  '/staff/cbl-dispute/$disputeId': typeof StaffCblDisputeDisputeIdRoute
  '/staff/ll88/$submissionId': typeof StaffLl88SubmissionIdRoute
  '/staff/ll97/$submissionId': typeof StaffLl97SubmissionIdRoute
  '/portal/buildings_/$buildingId/ll97': typeof PortalBuildingsBuildingIdLl97Route
  '/vendors_/ll87_/$vendorId/': typeof VendorsLl87VendorIdIndexRoute
  '/buildings_/$buildingId/ll88_/$ll88SubmissionId/overview': typeof BuildingsBuildingIdLl88Ll88SubmissionIdOverviewRoute
  '/buildings_/$buildingId/ll97_/$ll97SubmissionId/overview': typeof BuildingsBuildingIdLl97Ll97SubmissionIdOverviewRoute
  '/buildings_/$buildingId/ll88_/$ll88SubmissionId/': typeof BuildingsBuildingIdLl88Ll88SubmissionIdIndexRoute
  '/buildings_/$buildingId/ll97_/$ll97SubmissionId/': typeof BuildingsBuildingIdLl97Ll97SubmissionIdIndexRoute
  '/portal/buildings_/$buildingId/ll87_/$ll87SubmissionId/overview': typeof PortalBuildingsBuildingIdLl87Ll87SubmissionIdOverviewRoute
  '/portal/buildings_/$buildingId/ll87_/$ll87SubmissionId/': typeof PortalBuildingsBuildingIdLl87Ll87SubmissionIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/connect_rewire'
    | '/login'
    | '/portal'
    | '/register'
    | '/settings'
    | '/welcome'
    | '/buildings/$buildingId'
    | '/cbl_disputes/$ll97SubmissionId'
    | '/chat-dev/cards-demo'
    | '/chat-dev/trace-demo'
    | '/external/auth_success'
    | '/external/initiate_utility_auth'
    | '/external/new_utility_connection'
    | '/external/password_reset_confirm'
    | '/external/password_reset_request'
    | '/external/utility_scope_selection'
    | '/owner/$token'
    | '/policies/data_usage'
    | '/policies/privacy'
    | '/policies/tos'
    | '/portal/chat'
    | '/portal/ll87-planner'
    | '/portal/settings'
    | '/portal/team'
    | '/portal/tracker'
    | '/portal/workflow'
    | '/staff/chat-debug'
    | '/buildings'
    | '/cbl_disputes'
    | '/filings'
    | '/portal/'
    | '/rdp'
    | '/staff'
    | '/account_activation/$uid/$token'
    | '/owner/$token/list'
    | '/portal/buildings/$buildingId'
    | '/portal/compliance/ll152'
    | '/rdp/ll88/$submissionId'
    | '/rdp/ll97/$submissionId'
    | '/staff/cbl-dispute/$disputeId'
    | '/staff/ll88/$submissionId'
    | '/staff/ll97/$submissionId'
    | '/portal/buildings/$buildingId/ll97'
    | '/vendors/ll87/$vendorId'
    | '/buildings/$buildingId/ll88/$ll88SubmissionId/overview'
    | '/buildings/$buildingId/ll97/$ll97SubmissionId/overview'
    | '/buildings/$buildingId/ll88/$ll88SubmissionId'
    | '/buildings/$buildingId/ll97/$ll97SubmissionId'
    | '/portal/buildings/$buildingId/ll87/$ll87SubmissionId/overview'
    | '/portal/buildings/$buildingId/ll87/$ll87SubmissionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/connect_rewire'
    | '/login'
    | '/register'
    | '/settings'
    | '/welcome'
    | '/buildings/$buildingId'
    | '/cbl_disputes/$ll97SubmissionId'
    | '/chat-dev/cards-demo'
    | '/chat-dev/trace-demo'
    | '/external/auth_success'
    | '/external/initiate_utility_auth'
    | '/external/new_utility_connection'
    | '/external/password_reset_confirm'
    | '/external/password_reset_request'
    | '/external/utility_scope_selection'
    | '/owner/$token'
    | '/policies/data_usage'
    | '/policies/privacy'
    | '/policies/tos'
    | '/portal/chat'
    | '/portal/ll87-planner'
    | '/portal/settings'
    | '/portal/team'
    | '/portal/tracker'
    | '/portal/workflow'
    | '/staff/chat-debug'
    | '/buildings'
    | '/cbl_disputes'
    | '/filings'
    | '/portal'
    | '/rdp'
    | '/staff'
    | '/account_activation/$uid/$token'
    | '/owner/$token/list'
    | '/portal/buildings/$buildingId'
    | '/portal/compliance/ll152'
    | '/rdp/ll88/$submissionId'
    | '/rdp/ll97/$submissionId'
    | '/staff/cbl-dispute/$disputeId'
    | '/staff/ll88/$submissionId'
    | '/staff/ll97/$submissionId'
    | '/portal/buildings/$buildingId/ll97'
    | '/vendors/ll87/$vendorId'
    | '/buildings/$buildingId/ll88/$ll88SubmissionId/overview'
    | '/buildings/$buildingId/ll97/$ll97SubmissionId/overview'
    | '/buildings/$buildingId/ll88/$ll88SubmissionId'
    | '/buildings/$buildingId/ll97/$ll97SubmissionId'
    | '/portal/buildings/$buildingId/ll87/$ll87SubmissionId/overview'
    | '/portal/buildings/$buildingId/ll87/$ll87SubmissionId'
  id:
    | '__root__'
    | '/'
    | '/connect_rewire'
    | '/login'
    | '/portal'
    | '/register'
    | '/settings'
    | '/welcome'
    | '/buildings/$buildingId'
    | '/cbl_disputes/$ll97SubmissionId'
    | '/chat-dev/cards-demo'
    | '/chat-dev/trace-demo'
    | '/external/auth_success'
    | '/external/initiate_utility_auth'
    | '/external/new_utility_connection'
    | '/external/password_reset_confirm'
    | '/external/password_reset_request'
    | '/external/utility_scope_selection'
    | '/owner/$token'
    | '/policies/data_usage'
    | '/policies/privacy'
    | '/policies/tos'
    | '/portal/chat'
    | '/portal/ll87-planner'
    | '/portal/settings'
    | '/portal/team'
    | '/portal/tracker'
    | '/portal/workflow'
    | '/staff/chat-debug'
    | '/buildings/'
    | '/cbl_disputes/'
    | '/filings/'
    | '/portal/'
    | '/rdp/'
    | '/staff/'
    | '/account_activation/$uid/$token'
    | '/owner_/$token/list'
    | '/portal/buildings/$buildingId'
    | '/portal/compliance/ll152'
    | '/rdp/ll88/$submissionId'
    | '/rdp/ll97/$submissionId'
    | '/staff/cbl-dispute/$disputeId'
    | '/staff/ll88/$submissionId'
    | '/staff/ll97/$submissionId'
    | '/portal/buildings_/$buildingId/ll97'
    | '/vendors_/ll87_/$vendorId/'
    | '/buildings_/$buildingId/ll88_/$ll88SubmissionId/overview'
    | '/buildings_/$buildingId/ll97_/$ll97SubmissionId/overview'
    | '/buildings_/$buildingId/ll88_/$ll88SubmissionId/'
    | '/buildings_/$buildingId/ll97_/$ll97SubmissionId/'
    | '/portal/buildings_/$buildingId/ll87_/$ll87SubmissionId/overview'
    | '/portal/buildings_/$buildingId/ll87_/$ll87SubmissionId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  Connect_rewireRoute: typeof Connect_rewireRoute
  LoginRoute: typeof LoginRoute
  PortalRoute: typeof PortalRouteWithChildren
  RegisterRoute: typeof RegisterRoute
  SettingsRoute: typeof SettingsRoute
  WelcomeRoute: typeof WelcomeRoute
  BuildingsBuildingIdRoute: typeof BuildingsBuildingIdRoute
  Cbl_disputesLl97SubmissionIdRoute: typeof Cbl_disputesLl97SubmissionIdRoute
  ChatDevCardsDemoRoute: typeof ChatDevCardsDemoRoute
  ChatDevTraceDemoRoute: typeof ChatDevTraceDemoRoute
  ExternalAuth_successRoute: typeof ExternalAuth_successRoute
  ExternalInitiate_utility_authRoute: typeof ExternalInitiate_utility_authRoute
  ExternalNew_utility_connectionRoute: typeof ExternalNew_utility_connectionRoute
  ExternalPassword_reset_confirmRoute: typeof ExternalPassword_reset_confirmRoute
  ExternalPassword_reset_requestRoute: typeof ExternalPassword_reset_requestRoute
  ExternalUtility_scope_selectionRoute: typeof ExternalUtility_scope_selectionRoute
  OwnerTokenRoute: typeof OwnerTokenRoute
  PoliciesData_usageRoute: typeof PoliciesData_usageRoute
  PoliciesPrivacyRoute: typeof PoliciesPrivacyRoute
  PoliciesTosRoute: typeof PoliciesTosRoute
  StaffChatDebugRoute: typeof StaffChatDebugRoute
  BuildingsIndexRoute: typeof BuildingsIndexRoute
  Cbl_disputesIndexRoute: typeof Cbl_disputesIndexRoute
  FilingsIndexRoute: typeof FilingsIndexRoute
  RdpIndexRoute: typeof RdpIndexRoute
  StaffIndexRoute: typeof StaffIndexRoute
  Account_activationUidTokenRoute: typeof Account_activationUidTokenRoute
  OwnerTokenListRoute: typeof OwnerTokenListRoute
  RdpLl88SubmissionIdRoute: typeof RdpLl88SubmissionIdRoute
  RdpLl97SubmissionIdRoute: typeof RdpLl97SubmissionIdRoute
  StaffCblDisputeDisputeIdRoute: typeof StaffCblDisputeDisputeIdRoute
  StaffLl88SubmissionIdRoute: typeof StaffLl88SubmissionIdRoute
  StaffLl97SubmissionIdRoute: typeof StaffLl97SubmissionIdRoute
  VendorsLl87VendorIdIndexRoute: typeof VendorsLl87VendorIdIndexRoute
  BuildingsBuildingIdLl88Ll88SubmissionIdOverviewRoute: typeof BuildingsBuildingIdLl88Ll88SubmissionIdOverviewRoute
  BuildingsBuildingIdLl97Ll97SubmissionIdOverviewRoute: typeof BuildingsBuildingIdLl97Ll97SubmissionIdOverviewRoute
  BuildingsBuildingIdLl88Ll88SubmissionIdIndexRoute: typeof BuildingsBuildingIdLl88Ll88SubmissionIdIndexRoute
  BuildingsBuildingIdLl97Ll97SubmissionIdIndexRoute: typeof BuildingsBuildingIdLl97Ll97SubmissionIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal': {
      id: '/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect_rewire': {
      id: '/connect_rewire'
      path: '/connect_rewire'
      fullPath: '/connect_rewire'
      preLoaderRoute: typeof Connect_rewireRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff/': {
      id: '/staff/'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof StaffIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rdp/': {
      id: '/rdp/'
      path: '/rdp'
      fullPath: '/rdp'
      preLoaderRoute: typeof RdpIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/': {
      id: '/portal/'
      path: '/'
      fullPath: '/portal/'
      preLoaderRoute: typeof PortalIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/filings/': {
      id: '/filings/'
      path: '/filings'
      fullPath: '/filings'
      preLoaderRoute: typeof FilingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cbl_disputes/': {
      id: '/cbl_disputes/'
      path: '/cbl_disputes'
      fullPath: '/cbl_disputes'
      preLoaderRoute: typeof Cbl_disputesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/buildings/': {
      id: '/buildings/'
      path: '/buildings'
      fullPath: '/buildings'
      preLoaderRoute: typeof BuildingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff/chat-debug': {
      id: '/staff/chat-debug'
      path: '/staff/chat-debug'
      fullPath: '/staff/chat-debug'
      preLoaderRoute: typeof StaffChatDebugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/workflow': {
      id: '/portal/workflow'
      path: '/workflow'
      fullPath: '/portal/workflow'
      preLoaderRoute: typeof PortalWorkflowRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/tracker': {
      id: '/portal/tracker'
      path: '/tracker'
      fullPath: '/portal/tracker'
      preLoaderRoute: typeof PortalTrackerRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/team': {
      id: '/portal/team'
      path: '/team'
      fullPath: '/portal/team'
      preLoaderRoute: typeof PortalTeamRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/settings': {
      id: '/portal/settings'
      path: '/settings'
      fullPath: '/portal/settings'
      preLoaderRoute: typeof PortalSettingsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/ll87-planner': {
      id: '/portal/ll87-planner'
      path: '/ll87-planner'
      fullPath: '/portal/ll87-planner'
      preLoaderRoute: typeof PortalLl87PlannerRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/chat': {
      id: '/portal/chat'
      path: '/chat'
      fullPath: '/portal/chat'
      preLoaderRoute: typeof PortalChatRouteImport
      parentRoute: typeof PortalRoute
    }
    '/policies/tos': {
      id: '/policies/tos'
      path: '/policies/tos'
      fullPath: '/policies/tos'
      preLoaderRoute: typeof PoliciesTosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/policies/privacy': {
      id: '/policies/privacy'
      path: '/policies/privacy'
      fullPath: '/policies/privacy'
      preLoaderRoute: typeof PoliciesPrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/policies/data_usage': {
      id: '/policies/data_usage'
      path: '/policies/data_usage'
      fullPath: '/policies/data_usage'
      preLoaderRoute: typeof PoliciesData_usageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/owner/$token': {
      id: '/owner/$token'
      path: '/owner/$token'
      fullPath: '/owner/$token'
      preLoaderRoute: typeof OwnerTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/external/utility_scope_selection': {
      id: '/external/utility_scope_selection'
      path: '/external/utility_scope_selection'
      fullPath: '/external/utility_scope_selection'
      preLoaderRoute: typeof ExternalUtility_scope_selectionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/external/password_reset_request': {
      id: '/external/password_reset_request'
      path: '/external/password_reset_request'
      fullPath: '/external/password_reset_request'
      preLoaderRoute: typeof ExternalPassword_reset_requestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/external/password_reset_confirm': {
      id: '/external/password_reset_confirm'
      path: '/external/password_reset_confirm'
      fullPath: '/external/password_reset_confirm'
      preLoaderRoute: typeof ExternalPassword_reset_confirmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/external/new_utility_connection': {
      id: '/external/new_utility_connection'
      path: '/external/new_utility_connection'
      fullPath: '/external/new_utility_connection'
      preLoaderRoute: typeof ExternalNew_utility_connectionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/external/initiate_utility_auth': {
      id: '/external/initiate_utility_auth'
      path: '/external/initiate_utility_auth'
      fullPath: '/external/initiate_utility_auth'
      preLoaderRoute: typeof ExternalInitiate_utility_authRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/external/auth_success': {
      id: '/external/auth_success'
      path: '/external/auth_success'
      fullPath: '/external/auth_success'
      preLoaderRoute: typeof ExternalAuth_successRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat-dev/trace-demo': {
      id: '/chat-dev/trace-demo'
      path: '/chat-dev/trace-demo'
      fullPath: '/chat-dev/trace-demo'
      preLoaderRoute: typeof ChatDevTraceDemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat-dev/cards-demo': {
      id: '/chat-dev/cards-demo'
      path: '/chat-dev/cards-demo'
      fullPath: '/chat-dev/cards-demo'
      preLoaderRoute: typeof ChatDevCardsDemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cbl_disputes/$ll97SubmissionId': {
      id: '/cbl_disputes/$ll97SubmissionId'
      path: '/cbl_disputes/$ll97SubmissionId'
      fullPath: '/cbl_disputes/$ll97SubmissionId'
      preLoaderRoute: typeof Cbl_disputesLl97SubmissionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/buildings/$buildingId': {
      id: '/buildings/$buildingId'
      path: '/buildings/$buildingId'
      fullPath: '/buildings/$buildingId'
      preLoaderRoute: typeof BuildingsBuildingIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff/ll97/$submissionId': {
      id: '/staff/ll97/$submissionId'
      path: '/staff/ll97/$submissionId'
      fullPath: '/staff/ll97/$submissionId'
      preLoaderRoute: typeof StaffLl97SubmissionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff/ll88/$submissionId': {
      id: '/staff/ll88/$submissionId'
      path: '/staff/ll88/$submissionId'
      fullPath: '/staff/ll88/$submissionId'
      preLoaderRoute: typeof StaffLl88SubmissionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff/cbl-dispute/$disputeId': {
      id: '/staff/cbl-dispute/$disputeId'
      path: '/staff/cbl-dispute/$disputeId'
      fullPath: '/staff/cbl-dispute/$disputeId'
      preLoaderRoute: typeof StaffCblDisputeDisputeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rdp/ll97/$submissionId': {
      id: '/rdp/ll97/$submissionId'
      path: '/rdp/ll97/$submissionId'
      fullPath: '/rdp/ll97/$submissionId'
      preLoaderRoute: typeof RdpLl97SubmissionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rdp/ll88/$submissionId': {
      id: '/rdp/ll88/$submissionId'
      path: '/rdp/ll88/$submissionId'
      fullPath: '/rdp/ll88/$submissionId'
      preLoaderRoute: typeof RdpLl88SubmissionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/compliance/ll152': {
      id: '/portal/compliance/ll152'
      path: '/compliance/ll152'
      fullPath: '/portal/compliance/ll152'
      preLoaderRoute: typeof PortalComplianceLl152RouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/buildings/$buildingId': {
      id: '/portal/buildings/$buildingId'
      path: '/buildings/$buildingId'
      fullPath: '/portal/buildings/$buildingId'
      preLoaderRoute: typeof PortalBuildingsBuildingIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/owner_/$token/list': {
      id: '/owner_/$token/list'
      path: '/owner/$token/list'
      fullPath: '/owner/$token/list'
      preLoaderRoute: typeof OwnerTokenListRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account_activation/$uid/$token': {
      id: '/account_activation/$uid/$token'
      path: '/account_activation/$uid/$token'
      fullPath: '/account_activation/$uid/$token'
      preLoaderRoute: typeof Account_activationUidTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vendors_/ll87_/$vendorId/': {
      id: '/vendors_/ll87_/$vendorId/'
      path: '/vendors/ll87/$vendorId'
      fullPath: '/vendors/ll87/$vendorId'
      preLoaderRoute: typeof VendorsLl87VendorIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/buildings_/$buildingId/ll97': {
      id: '/portal/buildings_/$buildingId/ll97'
      path: '/buildings/$buildingId/ll97'
      fullPath: '/portal/buildings/$buildingId/ll97'
      preLoaderRoute: typeof PortalBuildingsBuildingIdLl97RouteImport
      parentRoute: typeof PortalRoute
    }
    '/buildings_/$buildingId/ll97_/$ll97SubmissionId/': {
      id: '/buildings_/$buildingId/ll97_/$ll97SubmissionId/'
      path: '/buildings/$buildingId/ll97/$ll97SubmissionId'
      fullPath: '/buildings/$buildingId/ll97/$ll97SubmissionId'
      preLoaderRoute: typeof BuildingsBuildingIdLl97Ll97SubmissionIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/buildings_/$buildingId/ll88_/$ll88SubmissionId/': {
      id: '/buildings_/$buildingId/ll88_/$ll88SubmissionId/'
      path: '/buildings/$buildingId/ll88/$ll88SubmissionId'
      fullPath: '/buildings/$buildingId/ll88/$ll88SubmissionId'
      preLoaderRoute: typeof BuildingsBuildingIdLl88Ll88SubmissionIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/buildings_/$buildingId/ll97_/$ll97SubmissionId/overview': {
      id: '/buildings_/$buildingId/ll97_/$ll97SubmissionId/overview'
      path: '/buildings/$buildingId/ll97/$ll97SubmissionId/overview'
      fullPath: '/buildings/$buildingId/ll97/$ll97SubmissionId/overview'
      preLoaderRoute: typeof BuildingsBuildingIdLl97Ll97SubmissionIdOverviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/buildings_/$buildingId/ll88_/$ll88SubmissionId/overview': {
      id: '/buildings_/$buildingId/ll88_/$ll88SubmissionId/overview'
      path: '/buildings/$buildingId/ll88/$ll88SubmissionId/overview'
      fullPath: '/buildings/$buildingId/ll88/$ll88SubmissionId/overview'
      preLoaderRoute: typeof BuildingsBuildingIdLl88Ll88SubmissionIdOverviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/buildings_/$buildingId/ll87_/$ll87SubmissionId/': {
      id: '/portal/buildings_/$buildingId/ll87_/$ll87SubmissionId/'
      path: '/buildings/$buildingId/ll87/$ll87SubmissionId'
      fullPath: '/portal/buildings/$buildingId/ll87/$ll87SubmissionId'
      preLoaderRoute: typeof PortalBuildingsBuildingIdLl87Ll87SubmissionIdIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/buildings_/$buildingId/ll87_/$ll87SubmissionId/overview': {
      id: '/portal/buildings_/$buildingId/ll87_/$ll87SubmissionId/overview'
      path: '/buildings/$buildingId/ll87/$ll87SubmissionId/overview'
      fullPath: '/portal/buildings/$buildingId/ll87/$ll87SubmissionId/overview'
      preLoaderRoute: typeof PortalBuildingsBuildingIdLl87Ll87SubmissionIdOverviewRouteImport
      parentRoute: typeof PortalRoute
    }
  }
}

interface PortalRouteChildren {
  PortalChatRoute: typeof PortalChatRoute
  PortalLl87PlannerRoute: typeof PortalLl87PlannerRoute
  PortalSettingsRoute: typeof PortalSettingsRoute
  PortalTeamRoute: typeof PortalTeamRoute
  PortalTrackerRoute: typeof PortalTrackerRoute
  PortalWorkflowRoute: typeof PortalWorkflowRoute
  PortalIndexRoute: typeof PortalIndexRoute
  PortalBuildingsBuildingIdRoute: typeof PortalBuildingsBuildingIdRoute
  PortalComplianceLl152Route: typeof PortalComplianceLl152Route
  PortalBuildingsBuildingIdLl97Route: typeof PortalBuildingsBuildingIdLl97Route
  PortalBuildingsBuildingIdLl87Ll87SubmissionIdOverviewRoute: typeof PortalBuildingsBuildingIdLl87Ll87SubmissionIdOverviewRoute
  PortalBuildingsBuildingIdLl87Ll87SubmissionIdIndexRoute: typeof PortalBuildingsBuildingIdLl87Ll87SubmissionIdIndexRoute
}

const PortalRouteChildren: PortalRouteChildren = {
  PortalChatRoute: PortalChatRoute,
  PortalLl87PlannerRoute: PortalLl87PlannerRoute,
  PortalSettingsRoute: PortalSettingsRoute,
  PortalTeamRoute: PortalTeamRoute,
  PortalTrackerRoute: PortalTrackerRoute,
  PortalWorkflowRoute: PortalWorkflowRoute,
  PortalIndexRoute: PortalIndexRoute,
  PortalBuildingsBuildingIdRoute: PortalBuildingsBuildingIdRoute,
  PortalComplianceLl152Route: PortalComplianceLl152Route,
  PortalBuildingsBuildingIdLl97Route: PortalBuildingsBuildingIdLl97Route,
  PortalBuildingsBuildingIdLl87Ll87SubmissionIdOverviewRoute:
    PortalBuildingsBuildingIdLl87Ll87SubmissionIdOverviewRoute,
  PortalBuildingsBuildingIdLl87Ll87SubmissionIdIndexRoute:
    PortalBuildingsBuildingIdLl87Ll87SubmissionIdIndexRoute,
}

const PortalRouteWithChildren =
  PortalRoute._addFileChildren(PortalRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  Connect_rewireRoute: Connect_rewireRoute,
  LoginRoute: LoginRoute,
  PortalRoute: PortalRouteWithChildren,
  RegisterRoute: RegisterRoute,
  SettingsRoute: SettingsRoute,
  WelcomeRoute: WelcomeRoute,
  BuildingsBuildingIdRoute: BuildingsBuildingIdRoute,
  Cbl_disputesLl97SubmissionIdRoute: Cbl_disputesLl97SubmissionIdRoute,
  ChatDevCardsDemoRoute: ChatDevCardsDemoRoute,
  ChatDevTraceDemoRoute: ChatDevTraceDemoRoute,
  ExternalAuth_successRoute: ExternalAuth_successRoute,
  ExternalInitiate_utility_authRoute: ExternalInitiate_utility_authRoute,
  ExternalNew_utility_connectionRoute: ExternalNew_utility_connectionRoute,
  ExternalPassword_reset_confirmRoute: ExternalPassword_reset_confirmRoute,
  ExternalPassword_reset_requestRoute: ExternalPassword_reset_requestRoute,
  ExternalUtility_scope_selectionRoute: ExternalUtility_scope_selectionRoute,
  OwnerTokenRoute: OwnerTokenRoute,
  PoliciesData_usageRoute: PoliciesData_usageRoute,
  PoliciesPrivacyRoute: PoliciesPrivacyRoute,
  PoliciesTosRoute: PoliciesTosRoute,
  StaffChatDebugRoute: StaffChatDebugRoute,
  BuildingsIndexRoute: BuildingsIndexRoute,
  Cbl_disputesIndexRoute: Cbl_disputesIndexRoute,
  FilingsIndexRoute: FilingsIndexRoute,
  RdpIndexRoute: RdpIndexRoute,
  StaffIndexRoute: StaffIndexRoute,
  Account_activationUidTokenRoute: Account_activationUidTokenRoute,
  OwnerTokenListRoute: OwnerTokenListRoute,
  RdpLl88SubmissionIdRoute: RdpLl88SubmissionIdRoute,
  RdpLl97SubmissionIdRoute: RdpLl97SubmissionIdRoute,
  StaffCblDisputeDisputeIdRoute: StaffCblDisputeDisputeIdRoute,
  StaffLl88SubmissionIdRoute: StaffLl88SubmissionIdRoute,
  StaffLl97SubmissionIdRoute: StaffLl97SubmissionIdRoute,
  VendorsLl87VendorIdIndexRoute: VendorsLl87VendorIdIndexRoute,
  BuildingsBuildingIdLl88Ll88SubmissionIdOverviewRoute:
    BuildingsBuildingIdLl88Ll88SubmissionIdOverviewRoute,
  BuildingsBuildingIdLl97Ll97SubmissionIdOverviewRoute:
    BuildingsBuildingIdLl97Ll97SubmissionIdOverviewRoute,
  BuildingsBuildingIdLl88Ll88SubmissionIdIndexRoute:
    BuildingsBuildingIdLl88Ll88SubmissionIdIndexRoute,
  BuildingsBuildingIdLl97Ll97SubmissionIdIndexRoute:
    BuildingsBuildingIdLl97Ll97SubmissionIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
